import { twMerge } from 'tailwind-merge';

export function Main({ className, children }) {
  return <main className={twMerge('mx-auto my-0 w-[37.3333333333rem] max-w-full', className)}>{children}</main>;
}
